import { ContentType } from './ContentType';

export const ContentTypeFilterAllOption = 'all';
export type ContentTypeFilterValue = typeof ContentTypeFilterAllOption | ContentType;
